import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-avis-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="text-2xl font-bold text-white">
                <span className="relative">
                  AVI'S
                  {/* <div className="absolute -top-1 right-0 w-1 h-6 bg-white transform translate-x-1">
                    <div className="absolute top-0 right-0 w-1 h-1 bg-white rounded-full"></div>
                    <div className="absolute top-1 right-0 w-2 h-1 bg-white rounded-full"></div>
                    <div className="absolute top-3 right-0 w-3 h-1 bg-white rounded-full"></div>
                  </div> */}
                </span>
              </div>
              <div className="text-xs text-gray-300 font-medium leading-tight">
                <div>ENGINEERING & CONSULTANCY</div>
                <div>NDTSERVICES</div>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Professional NDT services with advanced technology and expert consultation. 
              Your trusted partner in non-destructive testing solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors duration-200">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/quotation" className="text-gray-300 hover:text-white transition-colors duration-200">
                  Request Quote
                </Link>
              </li>
              <li>
                <Link to="/admin" className="text-gray-300 hover:text-white transition-colors duration-200">
                  Admin Portal
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Information</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p>
                <span className="font-medium">Email:</span> avis.engineering2025@gmail.com
              </p>
              <p>
                <span className="font-medium">Phone:</span> 7887985350
              </p>
              <p>
                <span className="font-medium">Address:</span><br />
                SR No-4/1A; plot on-: 17<br />
                SHREE SWAMI SAMARTH NIWAS<br />
                Bistabag, Savedi, Ahilyanagar
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 Avis Engineering & Consultancy. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
